module.exports = __webpack_public_path__ + "img/wlx_code_2.30030b95.png";